import { render } from "./DewitteContact.vue?vue&type=template&id=12588d2d&scoped=true"
const script = {}

import "./DewitteContact.vue?vue&type=style&index=0&id=12588d2d&scoped=true&lang=css"

import exportComponent from "/Users/macbook13dbs1/Documents/Vue/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12588d2d"]])

export default __exports__